module.exports = __webpack_public_path__ + "img/img56.12b24df3.png";